/* global window */
'use strict';

import Form from './form.jsx';
import React from 'react';
import ReactDOM from 'react-dom';


class Page {
    static blastoff() {

        this.mainElement = ReactDOM.render(
            <Form />,
            window.document.getElementById('app-mount')
        );
    }
}


export default Page;


/* $lab:coverage:off$ */
if (!module.parent) {
    window.page = Page;
    Page.blastoff();
}
/* $lab:coverage:on$ */
